import { Link } from "react-router-dom";
import styles from "./mobile-news-search.module.css";

export default function MobileNewsSearch({ item }) {
  return (
    <Link to={`/news/show/${item.id}`}>
      <div className={styles.mobileSearchWrapper}>
        <div>
          <i className="fa fa-newspaper"></i>
        </div>
        <div>
          {item.title}
          <span className={styles.publishDate}>{item.publish_date}</span>
        </div>
      </div>
    </Link>
  );
}
